import { render, staticRenderFns } from "./CategoryParams.vue?vue&type=template&id=8e3ddae8&scoped=true"
import script from "./CategoryParams.vue?vue&type=script&lang=ts"
export * from "./CategoryParams.vue?vue&type=script&lang=ts"
import style0 from "./CategoryParams.vue?vue&type=style&index=0&id=8e3ddae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3ddae8",
  null
  
)

export default component.exports